<template>
    <div id="container" class="sub-container">
        <div class="container_inner">
            <div class="covid19_content">
                <h3>코로나 19 발생동향</h3>
                <div class="content_area2">
                    <div class="left_area">
                        <ul>
                            <li v-for="chart in chartList">
                                <CovidChart :area-seq="chart.areaSeq" :chart-infos="chart.charts" />
                            </li>
                        </ul>
                    </div>

                    <div class="right_area">
                        <CovidMap />
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { $_WC } from '@/confs/common.const.js';
import CovidChart from "@/views/covid/CovidChart.vue";
import CovidMap from "@/views/covid/CovidMap.vue";

export default {
    components: {
        CovidChart,
        CovidMap,
    },
    data(){
        return {
            chartList: [
                { areaSeq: 1, charts: [1116, 1196, 1197, 1198, 1199, 1156]},
                { areaSeq: 2, charts: [1176, 1120, 1118]},
                // 1117
            ],
        };
    },
    computed: {
    },
    methods: {
    }
}
</script>
